import styled from 'styled-components'
interface RenderHtmlProps {
  html: string
}
export const RenderHtml = (
  props: RenderHtmlProps & React.ComponentProps<typeof RenderHtmlContainer>,
) => {
  const { html, ...other } = props
  const file = new Blob(['\ufeff', html], {
    type: 'text/html',
  })
  const url = URL.createObjectURL(file)
  return <RenderHtmlContainer src={url} {...other} />
}

const RenderHtmlContainer = styled.iframe`
  width: 100%;
  height: 100%;
`
